import React from 'react';
import { Route, Redirect } from 'react-router';
import AuthenticatedLayoutRoute from '../../layout/AuthenticatedLayoutRoute';
import pages from './pages';
import legacyPages from './legacyPages';

const IframePage = React.lazy(() => import(/* webpackChunkName: "IframePage" */ '.'));

const routes = () => {
    const redirectRoutes = legacyPages.map(({ from, to }) => (
        <Route key={from} exact path={from}>
            <Redirect to={to} />
        </Route>
    ));
    const pageRoutes = pages.map(({ path, ...pageProps }) => (
        <AuthenticatedLayoutRoute
            path={path}
            exact
            key={path}
            withConstellation={false}
            withStickyHeader
            withFooter={false}
        >
            <IframePage {...pageProps} />
        </AuthenticatedLayoutRoute>
    ));
    return [...redirectRoutes, ...pageRoutes];
};

export default routes;
